export default __webpack_public_path__ + "static/media/marking--discrete--crosswalk-zebra.41655dfd.png";